import { Refined_Content, tempStorage } from 'common/api/constructor';
import useMediaQueries from 'hooks/useMediaQueries';
import React, { useEffect, useState, memo } from 'react';
import { NavLink } from 'react-router-dom';
import { getPath, Routes } from 'routes';

export const ConstructorRefinedContent = memo(() => {
    const [banner, setBanner] = useState<Refined_Content | null | undefined>();
    const [imgWidth, setImgWidth] = useState<number | undefined>();
    useEffect(() => {
        tempStorage.listen((value) => {
            setBanner(value);
        });
    }, []);

    useMediaQueries({
        '(max-width: 648px)': () => {
            setImgWidth(undefined);
        },
        '(min-width: 647px)': () => {
            setImgWidth(560);
        },
    });

    const url = getUrl(banner?.ctaLink);

    return (
        <div className="px-4">
            {url ? (
                <NavLink className="block w-fit my-6 mx-auto" to={url}>
                    <img width={imgWidth} className="rounded-md" src={banner?.assetUrl} />
                </NavLink>
            ) : (
                <img width={imgWidth} className="my-6 mx-auto rounded-md" src={banner?.assetUrl} />
            )}
        </div>
    );
});

const getUrl = (url?: string): string | undefined => {
    if (url) {
        const match = url.match(/\d+-\w+/g);

        if (match?.length) {
            return getPath(Routes.BrandsDetails, { id: match[0] });
        }
    }
    return undefined;
};
